import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "px-6 py-2"
};
const _hoisted_2 = {
  class: "table"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "table-number"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_main_header = _resolveComponent("main-header");
  const _component_LlSecondaryButton = _resolveComponent("LlSecondaryButton");
  return $data.charges ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_main_header, {
    content: "Fixed Fee Templates"
  }), _createElementVNode("table", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("thead", null, [_createElementVNode("tr", null, [_createElementVNode("th", null, "Label"), _createElementVNode("th", null, "Product/Service"), _createElementVNode("th", null, "Invoice User"), _createElementVNode("th", {
    class: "table-number"
  }, "Amount")])], -1)), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.charges, charge => {
    return _openBlock(), _createElementBlock("tr", {
      key: charge.id,
      onClick: $event => $options.updateCharge({
        chargeId: charge.id,
        ledes: $data.ledes,
        fixedFeeTemplate: true
      }),
      class: "cursor-pointer"
    }, [_createElementVNode("td", null, _toDisplayString(charge.label || charge.description), 1), _createElementVNode("td", null, _toDisplayString(charge.accounting?.service?.name || '-'), 1), _createElementVNode("td", null, _toDisplayString(charge.account?.name || '-'), 1), _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.formatCurrency(charge.amount)), 1)], 8, _hoisted_3);
  }), 128))])]), _createElementVNode("p", null, [_createVNode(_component_LlSecondaryButton, {
    onClick: _cache[0] || (_cache[0] = $event => $options.updateCharge({
      ledes: $data.ledes,
      fixedFeeTemplate: true
    }))
  }, {
    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode(" Add Fixed Fee Template ", -1)]))]),
    _: 1
  })]), _cache[3] || (_cache[3] = _createElementVNode("div", null, [_createElementVNode("p", {
    class: "py-2"
  }, [_createElementVNode("span", {
    class: "fa fa-warning"
  }), _createTextVNode(" Fixed fee templates are shared with everyone in firm ")])], -1))])) : _createCommentVNode("", true);
}